export default __webpack_public_path__ + "static/media/BGLayer2a.354e2548.png";